import React, { useEffect, useState } from 'react';
import { Star } from '@mui/icons-material'
import founderimg from '../../assets/img/founder.webp';
import { useDispatch, useSelector } from 'react-redux';
import { clearData, upcommingUserList } from '../../store/apiSlice/UpcommingSlice';
import nannyicon from '../../assets/img/nany_icon.png';
import { Form, Modal } from 'react-bootstrap';
import { Addratingbooking, clearData as clearRatingData } from '../../store/apiSlice/AddRatingToBookingSlice';

const STATUS_LABELS = {
    0: "Pending",
    1: "Accepted",
    2: "On The Way",
    3: "Reached",
    4: "Completed",
    5: "Cancelled",
    6: "Rejected",
};


const PastUser = () => {

    const pastData = useSelector((state) => state.rootReducer.upcommingReducer.data)
    const [dataList, setDataList] = useState(null)
    const rateingData = useSelector((state) => state.rootReducer.AddratingbookingReducer.data)
    const [bookingId, setbookingId] = useState('')
    const [comment, setcomment] = useState('')
    const [loading, setLoading] = useState(true);

    const dispatch = useDispatch()
    useEffect(() => {
        setLoading(true);
        dispatch(clearData());
        dispatch(clearRatingData())
        dispatch(upcommingUserList(2)).finally(() => {
            setLoading(false);
        });
    }, []);
    useEffect(() => {
        if (rateingData && rateingData.status === 1) {
            dispatch(upcommingUserList(2))
        }
    }, [rateingData]);

    useEffect(() => {
        if (pastData != null && pastData.status === 1) {
            setDataList(pastData.data.data)
        }
    }, [pastData])

    const [show, setShow] = useState(false);

    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);

    const [rating, setRating] = useState(0); // Initial rating is 0

    const handleStarClick = (value) => {
        setRating(value);
    };

    const onClickRateing = () => {
        const payload = {
            bookingId: bookingId,
            star: rating,
            comment: comment,
        };
        dispatch(Addratingbooking(payload));
        handleClose();
    };

    return (
        <>
            {loading ? (<p>Loading...</p>) : (<>
                <div className="row all_order_box">
                    {dataList != null &&
                        dataList.length > 0 ? (
                        dataList.map((item, idx) =>
                            <div key={idx} className='col-md-6'>
                                <div className='card nany_orders my-2'>
                                    <div className='card.body d-flex'>
                                        <div className='card.img mr-2'>
                                            <img alt='profile' src={item.nannyId.profileImage} className="rounded-circle" />
                                        </div>
                                        <div>
                                            <div className='card-title'>
                                                <h6>{item.nannyId.firstName} {item.nannyId.lastName}</h6>
                                                <p className="text-sm-end text-md-start text-lg-end">${item.price}</p>
                                            </div>

                                            <div className='Card.Text'>
                                                <div className="nanny-info">
                                                    <div className="location mb-1 d-flex align-items-baseline"><span>{item.address}</span></div>
                                                    <p className="time mb-0 text-truncate">{item.date} <span>{item.time}</span></p>
                                                    <p> {item.ratingStar === 0 ? <button type='button' className='rateing-btn' onClick={() => {
                                                        setbookingId(item._id)
                                                        handleShow();
                                                    }}>
                                                        Rate This Booking
                                                    </button> :
                                                        // <span className='star'><Star /> {item.ratingStar}.0</span>
                                                        (Number(item.ratingStar) > 0 && (
                                                            <p>
                                                                <span className="star">
                                                                    <Star /> {Number(item.ratingStar).toFixed(1)}
                                                                </span>
                                                            </p>
                                                        ))
                                                    }
                                                    </p>
                                                </div>

                                            </div>
                                        </div>
                                    </div>
                                    {/* <div className='ordered_persons'>
                                        <div className='nanny-small-info mt-2'>
                                            <div className='d-flex justify-content-between'>
                                                <div className='d-flex justify-content-center'>
                                                    <img src={founder} alt='nanny' className="rounded-circle" />
                                                    <div className='d-flex align-items-center'>
                                                        <h4>{item.categoryId.name}</h4>
                                                    </div>
                                                </div>
                                                <div >
                                                    <button type='button' className='btn-success-nany'>Completed</button>
                                                </div>
                                            </div>
                                        </div>
                                    </div> */}

                                    <div className='ordered_persons'>
                                        <div className="nanny-small-info mt-2">
                                            <div className="d-flex justify-content-between align-items-center">

                                                <div className="d-flex align-items-center">
                                                    <img
                                                        src={founderimg}
                                                        alt="nanny"
                                                        className="rounded-circle me-2"
                                                        width={40}
                                                        height={40}
                                                    />
                                                    <h4 className="mb-0">{item.categoryId?.name}</h4>
                                                </div>

                                                {/* RIGHT: STATUS */}
                                                <span
                                                    className={`status-badge status-${item.status ?? 0}`}
                                                >
                                                    {STATUS_LABELS[item.status] || "Pending"}
                                                </span>

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        )
                    )
                        :
                        (
                            <p style={{ fontWeight: 600 }}>No Bookings Found</p>
                        )
                    }
                </div>

                <Modal show={show} onHide={handleClose} className="modal_address change_time chat_modal">
                    <Modal.Header closeButton className='rateing-modal-header'>
                    </Modal.Header>
                    <Modal.Body className='rateing_stars'>
                        <div className='nannyicon d-flex '>
                            <img src={nannyicon} alt='nannyicon' />
                        </div>

                        <p>Rate Your last Booking</p>
                        <h5>
                            {[...Array(5)].map((_, index) => {
                                const ratingValue = index + 1;
                                return (
                                    <span
                                        className='rating-star-icon'
                                        key={ratingValue}
                                        onClick={() => handleStarClick(ratingValue)}
                                        style={{ cursor: 'pointer', color: ratingValue <= rating ? 'gold' : 'grey' }}
                                    >
                                        &#9733;
                                    </span>
                                );
                            })}
                        </h5>
                        <Form>
                            <Form.Group className="mb-3" controlId="exampleForm.ControlTextarea1">
                                <Form.Control as="textarea" rows={3} placeholder='Review' onChange={(val) => setcomment(val.target.value)} />
                            </Form.Group>
                        </Form>
                    </Modal.Body>
                    <Modal.Footer>
                        <button className='submit_btn-rateing' type='submit' onClick={() => onClickRateing()}>
                            SUBMIT
                        </button>
                    </Modal.Footer>
                </Modal>
            </>)}
        </>
    )
}

export default PastUser
